module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-portal-3.1bb57373.svg";